var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlineNoteSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesaxoutlinenote-remove"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 0L24 0L24 24L0 24L0 0L24 0Z",
    id: "vuesaxoutlinenote-remove",
    fill: "none",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "vuesaxoutlinenote-remove"
  }, /*#__PURE__*/React.createElement("g", {
    id: "note-remove"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 14.75C6.59 14.75 6.25 14.41 6.25 14C6.25 13.59 6.59 13.25 7 13.25L12 13.25C12.41 13.25 12.75 13.59 12.75 14C12.75 14.41 12.41 14.75 12 14.75L7 14.75Z",
    id: "Vector",
    fill: "{props.color}",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 10.75C6.59 10.75 6.25 10.41 6.25 10C6.25 9.59 6.59 9.25 7 9.25L15 9.25C15.41 9.25 15.75 9.59 15.75 10C15.75 10.41 15.41 10.75 15 10.75L7 10.75Z",
    id: "Vector",
    fill: "{props.color}",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo",
    transform: "translate(2.27 1.27)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.5748 3.7751L5.5748 4.7751C5.8748 5.0751 5.8748 5.5751 5.5748 5.8751C5.2748 6.1751 4.7748 6.1751 4.4748 5.8751L3.47481 4.8751C3.17481 4.5751 3.17481 4.0751 3.47481 3.7751C3.6748 3.6751 3.8748 3.5751 4.0748 3.5751C4.27481 3.5751 4.4748 3.6751 4.5748 3.7751L4.5748 3.7751Z",
    id: "Sendero",
    fill: "{props.color}",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.7 5.6C1.2 5.6 0 4.3 0 2.8C0 1.3 1.2 0 2.8 0C4.4 0 5.5 1.3 5.5 2.8C5.5 4.3 4.2 5.6 2.7 5.6L2.7 5.6ZM2.7 1.6C2 1.6 1.5 2.1 1.5 2.8C1.5 3.5 2.1 4 2.7 4C3.3 4 3.9 3.4 3.9 2.8C3.9 2.2 3.4 1.6 2.7 1.6L2.7 1.6Z",
    id: "Forma",
    fill: "{props.color}",
    fillRule: "evenodd",
    stroke: "none"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M20.25 16L20.25 7.99C20.25 3.76 18.81 2.9 15.96 2.75L10 2.75C9.59 2.75 9.25 2.41 9.25 2C9.25 1.59 9.59 1.25 10 1.25L16 1.25C20.1 1.47 21.75 3.42 21.75 7.99L21.75 16C21.75 16.41 21.41 16.75 21 16.75C20.59 16.75 20.25 16.41 20.25 16Z",
    id: "Vector",
    fill: "{props.color}",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 22.7498C3.38 22.7498 2.25 20.1598 2.25 15.9798L2.25 9.00977C2.25 8.59977 2.59 8.25977 3 8.25977C3.41 8.25977 3.75 8.59977 3.75 9.00977L3.75 15.9798C3.75 19.6998 4.48 21.2498 9 21.2498L15 21.2498C15.41 21.2498 15.75 21.5898 15.75 21.9998C15.75 22.4098 15.41 22.7498 15 22.7498L9 22.7498Z",
    id: "Vector",
    fill: "{props.color}",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.71 22.69C14.43 22.57 14.25 22.3 14.25 22L14.25 19C14.25 16.58 15.58 15.25 18 15.25L21 15.25C21.3 15.25 21.58 15.43 21.69 15.71C21.8 15.99 21.74 16.31 21.53 16.53L15.53 22.53C15.39 22.67 15.19 22.75 15 22.75C14.9 22.75 14.81 22.73 14.71 22.69ZM15.75 19L15.75 20.19L19.19 16.75L18 16.75C16.42 16.75 15.75 17.42 15.75 19Z",
    id: "Vector",
    fill: "{props.color}",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 0L24 24L0 24L0 0L24 0Z",
    id: "Vector",
    fill: "none",
    fillRule: "evenodd",
    stroke: "none"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineNoteSearch);
export default __webpack_public_path__ + "static/media/vuesax-outline-note-search.01ccb110aa60d110360779dc1a4880ff.svg";
export { ForwardRef as ReactComponent };